import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";
import "./style.css";
import boldIcon from "../../assets/icons/bold.svg";
import italicIcon from "../../assets/icons/italic.svg";
import underlineIcon from "../../assets/icons/underline.svg";
import strikethroughIcon from "../../assets/icons/strikethrough.svg";
import linkIcon from "../../assets/icons/link.svg";
import olIcon from "../../assets/icons/ordered-list.svg";
import ulIcon from "../../assets/icons/unordered-list.svg";
import alignLeftIcon from "../../assets/icons/text-align-left.svg";
import alignRightIcon from "../../assets/icons/text-align-right.svg";
import alignCenterIcon from "../../assets/icons/text-align-center.svg";

const SummerNote = ({ name, label, height, value, required, error, onChange, saving, hint, disabled = false }) => {
    const editorRef = useRef(null);
    const timeoutRef = useRef(null);
    const [editorValue, setEditorValue] = useState(value);
   
    useEffect(() => {
      if (!editorRef.current || value === undefined) return;

        const editor = $(editorRef.current);

        if (!editor.data("initialized")) {
            editor.summernote({
                tabsize: 1,
                height: height,
                buttons: {                    
                    orderedList : function (context) {
                        var ui = $.summernote.ui;
                        var button = ui.button({
                          contents: `<img src=${olIcon} width="18px" height="18px" />`,
                          tooltip: false,
                          click: function () {
                            context.invoke('insertOrderedList');
                          }
                        });
                      
                        return button.render(); 
                      }, 
                      unorderedList : function (context) {
                        var ui = $.summernote.ui;
                        var button = ui.button({
                          contents: `<img src=${ulIcon} width="18px" height="18px" />`,
                          tooltip: false,
                          click: function () {
                            context.invoke('insertUnorderedList');
                          }
                        });
                      
                        return button.render(); 
                      },
                      alignLeft : function (context) {
                        var ui = $.summernote.ui;
                        var button = ui.button({
                          contents: `<img src=${alignLeftIcon} width="18px" height="18px" />`,
                          tooltip: false,
                          click: function () {
                            context.invoke(`justifyLeft`);
                          }
                        });
                      
                        return button.render(); 
                      },
                      alignCenter : function (context) {
                        var ui = $.summernote.ui;
                        var button = ui.button({
                          contents: `<img src=${alignCenterIcon} width="18px" height="18px" />`,
                          tooltip: false,
                          click: function () {
                            context.invoke(`justifyCenter`);
                          }
                        });
                      
                        return button.render(); 
                      },
                      alignRight : function (context) {
                        var ui = $.summernote.ui;
                        var button = ui.button({
                          contents: `<img src=${alignRightIcon}  width="18px" height="18px"/>`,
                          tooltip: false,
                          click: function () {
                            context.invoke(`justifyRight`);
                          }
                        });
                      
                        return button.render(); 
                      }
                },
                toolbar: [
                    ['fonts', ['fontsize' ]],  
                    ['fontstyle', ['forecolor','backcolor']],  
                    ['style', ['bold', 'italic', 'underline', 'strikethrough']],  
                    ['table', ['table']], 
                    ['list', ['orderedList', 'unorderedList','alignLeft', 'alignCenter','alignRight', 'codeview']],  
                ],
                fontNames: ["Roboto",'Arial', 'Courier New', 'Times New Roman', 'Verdana'], 
                fontSizes: ['8', '10', '12', '14', '16', '18', '24', '36'] ,
                icons: {
                    bold: `<img src=${boldIcon} width="18px" height="18px" />`,
                    italic: `<img src=${italicIcon} width="18px" height="18px" />`,
                    underline: `<img src=${underlineIcon} width="18px" height="18px" />`,
                    strikethrough: `<img src=${strikethroughIcon} width="18px" height="18px" />`,
                    link: `<img src=${linkIcon} width="18px" height="18px" />`,
                    },                               
                callbacks: {
                    onChange: (contents) => {
                      if(saving) return;
                      setEditorValue(contents);
                    }
                }
            });

            editor.data("initialized", true);
        }

        if (editor.summernote("code") !== value) {
          editor.summernote("code", value);
          setEditorValue(value);
      }

        if (disabled) {
          editor.summernote('disable');
        } else {
          editor.summernote('enable');
        }

        return () => {
            if (editor.data("initialized")) {
                editor.summernote("destroy");
                editor.removeData("initialized");
            }
        };
    }, [height, name,value, disabled]); 

    useEffect(() => {
      if (saving) {
          onChange({ target: { name, value: editorValue } });
      }
  }, [saving, editorValue, onChange, name]);
    
    return (
        <>
            <label htmlFor={`input-${name}`} className={required ? "input-required" : ""}>
                {label}
            </label>
            <div
                ref={editorRef}
                id={`summernote-${name}`}
                onBlur={() => {
                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                    onChange({ target: { name, value: editorValue } }); 
                }}
            >                
            </div>

            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default SummerNote;
